/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export var editorProps = {
    apiKey: String,
    cloudChannel: String,
    id: String,
    init: Object,
    initialValue: String,
    inline: Boolean,
    modelEvents: [String, Array],
    plugins: [String, Array],
    tagName: String,
    toolbar: [String, Array],
    value: String,
    disabled: Boolean
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@tinymce_tinymce-vue@1.1.2@@tinymce/tinymce-vue/lib/es2015/components/EditorPropTypes.js
// module id = null
// module chunks = 